import { render, staticRenderFns } from "./LocalisedText.vue?vue&type=template&id=7b353626"
import script from "./LocalisedText.vue?vue&type=script&lang=js"
export * from "./LocalisedText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b353626')) {
      api.createRecord('7b353626', component.options)
    } else {
      api.reload('7b353626', component.options)
    }
    module.hot.accept("./LocalisedText.vue?vue&type=template&id=7b353626", function () {
      api.rerender('7b353626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/LocalisedText.vue"
export default component.exports